
  import { Component, Mixins } from 'vue-property-decorator'
  import IconsMixin from '@/mixins/IconsMixin.vue'
  import AuthMixin from '@/mixins/AuthMixin.vue'
  import LabeledValue from '@/components/LabeledValue.vue'
  import {
    Company,
    CompanyCollection,
    CompanyTypeEnum,
    IVendorPriceListEntry,
    Order,
    OrderCollection, OrderEntry,
    OrderTypeEnum, PriceList, PriceListEntry, PriceListCollection
  } from '@/firestore'
  import LoadingPage from '@/components/LoadingPage.vue'
  import moment from 'moment'
  import ProductSelector from '@/components/Order/ProductSelector.vue'
  import OrderBarcodeScanDialog from '@/components/Barcode/OrderBarcodeScanDialog.vue'

  @Component({
    components: { OrderBarcodeScanDialog, ProductSelector, LoadingPage, LabeledValue }
  })
  export default class OrderEdit extends Mixins(IconsMixin, AuthMixin) {
    public order: Order | null = null
    public formValid: boolean = false

    public displayBarcodeScanner: boolean = false

    public vendors: Company[] = []
    public priceListEntries: IVendorPriceListEntry[] = []

    get isValid() {
      return this.formValid && this.order && this.order.orderEntries.length > 0
    }

    get deliveryDate(): string | undefined {
      if (this.order) {
        return moment(this.order.dateExpected).local().format('YYYY-MM-DD')
      }
    }

    set deliveryDate(date: string | undefined) {
      if (this.order) {
        this.order.dateExpected = date ? moment(date).toDate() : undefined
      }
    }

    public async mounted() {
      if (this.$route.params.id === 'create') {
        this.order = this.createNewOrder()
        this.addOrderEntry()
      } else {
        this.order = await this.lookupExistingOrder(this.$route.params.id)
      }

      if (!this.order) {
        return await this.$router.push({ name: 'page-not-found' })
      }

      const companyCollection = new CompanyCollection(( await this.$firebase ).firestore())
      this.vendors = companyCollection.watchCompaniesByType(CompanyTypeEnum.VENDOR)

      const priceListCollection = new PriceListCollection(( await this.$firebase ).firestore())
      const priceLists = await priceListCollection.listPriceListsByCompanyId(this.userClaim.company_id, this.userClaim.company_type)

      priceLists.forEach((priceList: PriceList) => {
        priceList.entries.forEach((entry: PriceListEntry) => {
          //todo: fix this before going live; check correct parameters
          this.priceListEntries.push({ ...entry, vendorCompanyId: priceList.vendorCompanyId,
            priceListId: priceList.id,
            vendorCompanyName: this.userCompany.id
          })
        })
      })
    }

    public lookupVendorName(vendorCompanyId: string): string {
      const vendor = this.vendors.find((c: Company) => c.id === vendorCompanyId)
      return vendor ? vendor.name : ''
    }

    public addScanEntry(entry: OrderEntry) {
      if (!this.order) {
        return
      }

      this.order.orderEntries.push(entry)
    }

    public addOrderEntry() {
      if (!this.order) {
        return
      }

      const entry = new OrderEntry('', '')
      this.order.orderEntries.push(entry)
    }

    public removeOrderEntry(entry: OrderEntry) {
      if (!this.order) {
        return
      }

      const index = this.order.orderEntries.indexOf(entry)
      if (index !== -1) {
        this.order.orderEntries.splice(index, 1)
      }
    }

    public async save() {
      if (!this.isValid || !this.order) {
        return
      }

      const collection = new OrderCollection(( await this.$firebase ).firestore())
      await collection.save(this.order)

      if (this.$route.params.id === 'create') {
        await this.$router.push({ name: 'order-details', params: { id: this.order.id } })
      } else {
        await this.$router.go(-1)
      }
    }

    private createNewOrder() {
      //todo: fix this before going live; check correct parameters
      return new Order('', OrderTypeEnum.RESTAURANT, this.user.uid, this.userClaim.company_id, this.userCompany.name, this.userClaim.company_id)
    }

    private async lookupExistingOrder(id: string) {
      const collection = new OrderCollection(( await this.$firebase ).firestore())
      const order = await collection.get(this.$route.params.id)
      if (!order || order.assignedCompanyId !== this.userClaim.company_id) {
        return null
      }

      return order
    }
  }
